exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#nexus{background:#030a03;width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden}#nexus .ui.message{margin:8px}#nexus .container{display:flex;width:100%;height:100%;position:relative}#nexus .container canvas{display:flex;width:100%;height:100%}#nexus .loading{color:#fefefe;font-size:120%;margin:8px;text-align:center}#nexus .loading .circle.notch{height:20px;width:22px}", ""]);

// exports
